import React from "react";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import TNPLogoSVG from "core/TNPLogo";

// component
export const TNPLogo = () => {
    const { isDarkMode } = useSiteHeader();
    return <TNPLogoSVG isDarkMode={isDarkMode} />;
};

export default TNPLogo;
